<template>
    <div class="table-responsive">
        <table class="table-bordered table">
            <colgroup>
                <col style="width: 200px" />
                <col style="width: auto" />
                <col style="width: 150px" />
                <col style="width: 150px" />
            </colgroup>
            <tbody>
                <tr>
                    <th>■CP概要</th>
                    <th></th>
                    <th>1次チェック</th>
                    <th>2次チェック</th>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_6(dataObject, isPreview)['応募フォーム']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_6(dataObject)['応募フォーム']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        registration_form: dataObject.registration_form
                                    })
                                "
                            />
                            応募ツール
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab6-textarea-1"
                            :model.sync="dataObject.registration_form.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['応募フォーム']"
                            :isPreview="isPreview"
                            :config="inputConfig.registration_form"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.registration_form_first)"
                            v-model="dataObject.registration_form.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('registration_form', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.registration_form_secondary)"
                            v-model="dataObject.registration_form.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('registration_form', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_6(dataObject, isPreview)['Lタゲ内該当キャンペーンID']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_6(dataObject)['Lタゲ内該当キャンペーンID']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        campaign_name_in_cr: dataObject.campaign_name_in_cr
                                    })
                                "
                            />
                            Lタゲ内該当キャンペーンID
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab6-textarea-2"
                            :model.sync="dataObject.campaign_name_in_cr.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['Lタゲ内該当キャンペーンID']"
                            :isPreview="isPreview"
                            :config="inputConfig.campaign_name_in_cr"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.campaign_name_in_cr_first)"
                            v-model="dataObject.campaign_name_in_cr.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('campaign_name_in_cr', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.campaign_name_in_cr_secondary)"
                            v-model="dataObject.campaign_name_in_cr.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('campaign_name_in_cr', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_6(dataObject, isPreview)['■CP概要その他先_6']">
                    <td class="bg-color1">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_6(dataObject)['■CP概要その他先_6']"
                            @change="toggleCommonSwitch($event, { free_block_campaign_overview: dataObject.free_block_campaign_overview })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_campaign_overview.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['■CP概要その他先_6']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['■CP概要その他先_6'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td>
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_campaign_overview.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-■CP概要その他先_6-${idTab}`"
                            :model.sync="dataObject.free_block_campaign_overview.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['■CP概要その他先_6'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>

                <tr>
                    <th colspan="4">■応募数報告</th>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_6(dataObject, isPreview)['報告スケジュール']">
                    <tr>
                        <td rowspan="2" class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_6(dataObject)['報告スケジュール']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            reporting_schedule: dataObject.reporting_schedule,
                                            reporting_schedule_detail: dataObject.reporting_schedule_detail
                                        })
                                    "
                                />
                                報告スケジュール
                            </div>
                        </td>
                        <td
                            :class="{
                                disabled_cursor: isDisabled
                            }"
                        >
                            <CommonMultiselect
                                v-model="dataObject.reporting_schedule.data"
                                :options.sync="option.reporting_schedule"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['報告スケジュール']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_first)"
                                v-model="dataObject.reporting_schedule.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('reporting_schedule', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_secondary)"
                                v-model="dataObject.reporting_schedule.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('reporting_schedule', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab6-textarea-3"
                                :model.sync="dataObject.reporting_schedule_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['報告スケジュール']"
                                :isPreview="isPreview"
                                :config="inputConfig.reporting_schedule_detail"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_detail_first)"
                                v-model="dataObject.reporting_schedule_detail.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('reporting_schedule_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.reporting_schedule_detail_secondary)"
                                v-model="dataObject.reporting_schedule_detail.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('reporting_schedule_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <template v-if="SWITCH_FIELD_TAB_6(dataObject, isPreview)['報告内容']">
                    <tr>
                        <td rowspan="2" class="bg-color1">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_6(dataObject)['報告内容']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            contents_of_report: dataObject.contents_of_report,
                                            contents_of_report_detail: dataObject.contents_of_report_detail
                                        })
                                    "
                                />
                                報告内容
                            </div>
                        </td>
                        <td
                            :class="{
                                disabled_cursor: isDisabled
                            }"
                        >
                            <CommonMultiselect
                                v-model="dataObject.contents_of_report.data"
                                :options.sync="option.contents_of_report"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['報告内容']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_first)"
                                v-model="dataObject.contents_of_report.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_secondary)"
                                v-model="dataObject.contents_of_report.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <TextareaComponent
                                id="tab6-textarea-4"
                                :model.sync="dataObject.contents_of_report_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['報告内容']"
                                :isPreview="isPreview"
                                :config="inputConfig.contents_of_report_detail"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_detail_first)"
                                v-model="dataObject.contents_of_report_detail.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.contents_of_report_detail_secondary)"
                                v-model="dataObject.contents_of_report_detail.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('contents_of_report_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <tr v-if="SWITCH_FIELD_TAB_6(dataObject, isPreview)['通数作成時の日時項目']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_6(dataObject)['通数作成時の日時項目']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        date_end_time_field: dataObject.date_end_time_field
                                    })
                                "
                            />
                            通数作成時の日時項目
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab6-textarea-5"
                            :model.sync="dataObject.date_end_time_field.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['通数作成時の日時項目']"
                            :isPreview="isPreview"
                            :config="inputConfig.date_end_time_field"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.date_end_time_field_first)"
                            v-model="dataObject.date_end_time_field.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('date_end_time_field', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.date_end_time_field_secondary)"
                            v-model="dataObject.date_end_time_field.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('date_end_time_field', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_6(dataObject, isPreview)['テスト応募']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_6(dataObject)['テスト応募']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        test_application: dataObject.test_application
                                    })
                                "
                            />
                            テスト応募
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab6-textarea-6"
                            :model.sync="dataObject.test_application.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['テスト応募']"
                            :isPreview="isPreview"
                            :config="inputConfig.test_application"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.test_application_first)"
                            v-model="dataObject.test_application.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('test_application', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.test_application_secondary)"
                            v-model="dataObject.test_application.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('test_application', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_6(dataObject, isPreview)['■応募数報告その他先_6']">
                    <td class="bg-color1">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_6(dataObject)['■応募数報告その他先_6']"
                            @change="toggleCommonSwitch($event, { free_block_report_number: dataObject.free_block_report_number })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_report_number.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['■応募数報告その他先_6']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['■応募数報告その他先_6'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td>
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_report_number.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-■応募数報告その他先_6-${idTab}`"
                            :model.sync="dataObject.free_block_report_number.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['■応募数報告その他先_6'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>

                <tr>
                    <th colspan="4">■その他(特記)</th>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_6(dataObject, isPreview)['無効内容の詳細']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_6(dataObject)['無効内容の詳細']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        invalid_content: dataObject.invalid_content
                                    })
                                "
                            />
                            無効内容の詳細
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab6-textarea-7"
                            :model.sync="dataObject.invalid_content.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['無効内容の詳細']"
                            :isPreview="isPreview"
                            :config="inputConfig.invalid_content"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.invalid_content_first)"
                            v-model="dataObject.invalid_content.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('invalid_content', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.invalid_content_secondary)"
                            v-model="dataObject.invalid_content.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('invalid_content', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_6(dataObject, isPreview)['その他連絡事項']">
                    <td class="bg-color1">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_6(dataObject)['その他連絡事項']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        other_information: dataObject.other_information
                                    })
                                "
                            />
                            その他連絡事項
                        </div>
                    </td>
                    <td>
                        <TextareaComponent
                            id="tab6-textarea-8"
                            :model.sync="dataObject.other_information.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['その他連絡事項']"
                            :isPreview="isPreview"
                            :config="inputConfig.other_information"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_information_first)"
                            v-model="dataObject.other_information.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_information', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_information_secondary)"
                            v-model="dataObject.other_information.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_information', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_6(dataObject, isPreview)['フリーブロックその他先']">
                    <td class="bg-color1">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_6(dataObject)['フリーブロックその他先']"
                            @change="toggleCommonSwitch($event, { free_block_other: dataObject.free_block_other })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_other.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['フリーブロックその他先']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['フリーブロックその他先'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td>
                        <div v-if="isNotCheckBoxPartner || isDisabled" class="box--text__disabled" v-html="dataObject.free_block_other.data"></div>
                        <Editor
                            v-else
                            :id="`editor-${idTab}`"
                            :model.sync="dataObject.free_block_other.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_6(dataObject)['フリーブロックその他先'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import CommonMultiselect from './CommonMultiselect.vue';
import Editor from '@/components/Editor/main.vue';
import editorDelayMixin from '@/mixins/editorDelayMixin';
import CommonCheckbox from '@/views/pages/require/components/CommonCheckbox.vue';
import TextareaComponent from '@/components/Textarea/main.vue';

import { formatDateTimeJapanese, toggleCommonSwitch, isRolePartner, onHandleDataCheckValueForPartner } from '@/views/pages/require/handlers';
import { SWITCH_FIELD_TAB_6, configHelperOptions, CONFIG_INPUT_TAB_6 } from '@/views/pages/require/const-field-tab';

export default {
    name: 'Tab6Require',
    mixins: [editorDelayMixin],
    props: {
        isNotCheckBoxPartner: {
            type: Boolean,
            default: () => false
        },
        keyTab: {
            type: [String],
            default: ''
        },
        idTab: {
            type: [String, Number],
            default: ''
        },
        dataObject: {
            type: Object,
            required: false
        },
        currentUser: {
            type: Object,
            required: false
        },
        detailBeginForDocument: {
            type: Object,
            required: false
        },
        isDisabled: {
            type: Boolean,
            required: false
        },
        isPreview: {
            type: Boolean,
            required: false
        },
        processingFields: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        CommonMultiselect,
        Editor,
        CommonCheckbox,
        TextareaComponent
    },
    data() {
        return {
            option: configHelperOptions.optionTab6,
            isRolePartner: isRolePartner(),
            inputConfig: CONFIG_INPUT_TAB_6()
        };
    },
    methods: {
        formatDateTimeJapanese,
        toggleCommonSwitch,
        SWITCH_FIELD_TAB_6,

        handleCheckBoxValue(fieldName, type) {
            const payload = onHandleDataCheckValueForPartner(this.keyTab, this.dataObject, fieldName);
            this.$emit('handleTabCheckBoxValue', { payload, fieldName, type });
        }
    },
    watch: {},
    mounted() {}
};
</script>

<style lang="scss" scoped>
.box8 input[type='text'] {
    width: 200px;
}
</style>
